module.exports = __webpack_public_path__ + "img/qqc_logo@3x.68da27b7.png";